import { gradeFilterFactory } from '@/catalog/constants/filterInputMeta/gradeFilterFactory';

export default gradeFilterFactory({
  id: 'integralV2.smc',
  name: 'Shape Normalized Performance v2 (Beta)',
  getter(filters) {
    return filters.integralV2Smc;
  },
  setter(value, filters) {
    return filters.setIntegralV2Smc(value);
  },
});
